import styled from 'styled-components';

export const Container = styled.div<{ $isWebview?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: ${({ $isWebview }) => ($isWebview ? '94vh' : '80vh')};
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    justify-content: unset;
    height: auto;
  }
`;

export const TextContainer = styled.div``;

export const ButtonContainer = styled.div`
  button {
    font-family: 'Roboto', Arial, sans-serif;
    width: 100%;
    font-weight: 400;
    font-size: 14px;
    border-radius: 8px;
  }
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    button {
      width: auto;
      padding: 10px 12px;
    }
  }
`;
